import { render, staticRenderFns } from "./ExtraInfoDialog.vue?vue&type=template&id=77afea4c"
import script from "./ExtraInfoDialog.vue?vue&type=script&lang=js"
export * from "./ExtraInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./ExtraInfoDialog.vue?vue&type=style&index=0&id=77afea4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports